module.exports = __webpack_public_path__ + "img/technology-bg.4c6bb837.svg";